import { render } from "./ThemesSection.vue?vue&type=template&id=16be2b6a&scoped=true&ts=true"
import script from "./ThemesSection.vue?vue&type=script&lang=ts"
export * from "./ThemesSection.vue?vue&type=script&lang=ts"

import "./ThemesSection.vue?vue&type=style&index=0&id=16be2b6a&scoped=true&lang=scss"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16be2b6a"]])

export default __exports__